<template>
  <div v-if="building" class="position-relative">
    <div id="message" class="row position-absolute disabledDashboardButton">
      <div class="col-md-12 text-center">
        <h1>🚧</h1>
        <h3>
          Dashboard em construção
        </h3>
        <p>Em breve teremos novidades</p>
      </div>
      <div class="mt-4">
        <router-link
            tag="button"
            to="/cm-taxas"
            class="btn btn-primary"
        >
          Acessar aplicativo
        </router-link>
      </div>
    </div>

    <div class="disabledDashboard">
      <div class="container-fluid">
        <div class="row mt-4">
          <div class="col-md-12 text-right">
            <strong class="last-update">Atualizado às XX:XX</strong>
            <button
                class="btn btn-primary ml-4"
                style="pointer-events: none;"
            >
              <RefreshCcwIcon/>
            </button>
            <router-link
                tag="button"
                to="/tickets"
                class="btn btn-primary btn-xl ml-3"
                style="pointer-events: none;"
            >
              Acessar aplicativo
            </router-link>
          </div>

        </div>
      </div>

      <div class="container-fluid">

        <div class="row">
          <div class="col-md-4">
            <div class="card card-status-top green-indicator text-uppercase">
              <p><strong>DATA 1</strong></p>
              <h3><strong> 456 </strong></h3>
            </div>
          </div>
          <div class="col-md-4">
            <div class="card card-status-top red-indicator text-uppercase">
              <p><strong>DATA 2</strong></p>
              <h3><strong> 193 </strong></h3>
            </div>
          </div>
          <div class="col-md-4">
            <div class="card card-status-top blue-indicator text-uppercase">
              <p><strong>DATA 3</strong></p>
              <h3><strong> 134 </strong></h3>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-3">
            <div class="card card-status-bottom">
              <p><strong>DATA 4</strong></p>
              <h5><strong> quantity </strong></h5>
            </div>
          </div>
          <div class="col-md-3">
            <div class="card card-status-bottom">
              <p><strong>DATA 5</strong></p>
              <h5><strong> quantity </strong></h5>
            </div>
          </div>
          <div class="col-md-3">
            <div class="card card-status-bottom">
              <p><strong>DATA 6</strong></p>
              <h5><strong> quantity </strong></h5>
            </div>
          </div>
          <div class="col-md-3">
            <div class="card card-status-bottom">
              <p><strong>DATA 7</strong></p>
              <h5><strong> quantity </strong></h5>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12 mt-4">
            <h5><strong>Multas por placa</strong></h5>
          </div>
          <table class="table table-borderless table-border table-align col-md-12">
            <thead>
            <tr>
              <th>Placa</th>
              <th>Renavam</th>
              <th>CNPJ</th>
              <th>Quantidade de Multas</th>
              <th>Valor total de Multas</th>
            </tr>
            </thead>
            <tbody>
              <tr>
                <td><strong>AAA-1234</strong></td>
                <td><strong>000000000</strong></td>
                <td><strong>00.000.000/0001-91</strong></td>
                <td><strong> 54 </strong></td>
                <td><strong> R$ 878,96 </strong></td>
              </tr>
              <tr>
                <td><strong>AAA-1234</strong></td>
                <td><strong>000000000</strong></td>
                <td><strong>00.000.000/0001-91</strong></td>
                <td><strong> 54 </strong></td>
                <td><strong> R$ 878,96 </strong></td>
              </tr>
              <tr>
                <td><strong>AAA-1234</strong></td>
                <td><strong>000000000</strong></td>
                <td><strong>00.000.000/0001-91</strong></td>
                <td><strong> 54 </strong></td>
                <td><strong> R$ 878,96 </strong></td>
              </tr>
              <tr>
                <td><strong>AAA-1234</strong></td>
                <td><strong>000000000</strong></td>
                <td><strong>00.000.000/0001-91</strong></td>
                <td><strong> 54 </strong></td>
                <td><strong> R$ 878,96 </strong></td>
              </tr>
              <tr>
                <td><strong>AAA-1234</strong></td>
                <td><strong>000000000</strong></td>
                <td><strong>00.000.000/0001-91</strong></td>
                <td><strong> 54 </strong></td>
                <td><strong> R$ 878,96 </strong></td>
              </tr>
            </tbody>
          </table>
        </div>

      </div>
    </div>
  </div>

  <div v-else>
    <div class="container-fluid">
      <div class="mt-4">
        <AlertBannerRecords path="/vehicles" :message="vehiclesMessage" />
        <AlertBannerRecords path="/maestro/fees" :message="scheduleMessage" />
      </div>
      <div class="row mt-4 mb-4">

        <div class="col-md-2">
          <label class="mr-2" for="period-type">
            Tipo de período
            <info-icon
                size="1x"
                v-tooltip.top="'Alguns órgãos podem não fornecer a data de ocorrência e estas multas não serão incluídas nos gráficos ao pesquisar por este tipo de período. ' +
                 'Para garantir a visualização de todas as multas, acesse o aplicativo e faça uma busca pelo status da multa'"
            />
          </label>
          <select @focusout="initializeData" v-model="periodType" id="period-type" class="form-control">
            <option value="occurred_at">Data da ocorrência</option>
            <option value="expired_at">Data de vencimento</option>
            <option value="updated_at">Data de atualização</option>
            <option value="created_at">Data de criação</option>
          </select>
        </div>

        <div class="col-md-2">
          <label for="start-date">Data inicial</label>
          <input v-model="startDate" @focusout="initializeData" type="date" id="start-date" class="form-control">
        </div>

        <div class="col-md-2">
          <label for="end-date">Data final</label>
          <input v-model="endDate" @focusout="initializeData" type="date" id="end-date" class="form-control">
        </div>

        <div class="col-md-6 float-right" style="display:flex; align-items: center; justify-content: end">
          <router-link
              tag="button"
              to="/cm-taxas"
              class="btn btn-primary btn-xl ml-3"
          >
            Acessar aplicativo
          </router-link>
        </div>
      </div>
    </div>
    <div class="container-fluid">
      <div class="row">

        <!-- Status -->
        <div class="col-md-4" v-for="status in listStatus" :key="status.title">
          <Card :data="status" :loading="objectLoad.status" data-sum/>
        </div>

        <div class="col-md-6">
          <div class="mt-3">
            <cm-frotas-pie-chart graph-title="Classificação" :classifications="classifications" :loading="objectLoad.graph"/>
          </div>
        </div>

        <div class="col-md-6">
          <div class="mt-3">
            <cm-frotas-chart graph-title="Órgãos autuadores" :graph-data="issuingAuthorities" :loading="objectLoad.graph1"/>
          </div>
        </div>
      </div>

      <!-- Vehicle Table -->
      <div class="row">
        <div class="col-md-12 mt-4 mb-2">
          <h5><strong>Multas por veículo</strong></h5>
        </div>

        <!-- Search -->
        <div class="col-md-4">
          <input
            class="input form-control"
            @keypress.enter="find()"
            v-model="generic"
            placeholder="Pesquisar por Placa ou Renavam"
          >
          <search-icon @click="find()" class="icon icon-within"/>
        </div>

        <Vehicles
          :vehicles="vehicles"
          :loading="objectLoad.vehicles"
          :endDate="endDate"
          :startDate="startDate"
          :periodType="periodType"
        />

        <div class="col-md-12">
          <Pagination
            v-model="meta.currentPage"
            :totalCount="meta.totalCount"
            :totalPages="meta.totalPages"
            @pagination="pagination"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import GetAccount from '@/mixins/GetAccount'
  import GetAccountApps from '@/mixins/GetAccountApps'

  import Card from '@/components/dashboard/dashboard_cm_frotas/Card.vue'
  import Vehicles from '@/components/dashboard/dashboard_cm_frotas/Vehicles.vue'

  import Pagination from '@/components/shares/specialTag/Pagination.vue';
  import CmFrotasChart from '@/components/charts/CmFrotasChart.vue';
  import CmFrotasPieChart from '@/components/charts/CmFrotasPieChart.vue';

  import { SearchIcon, InfoIcon, RefreshCcwIcon } from 'vue-feather-icons'
  import { IssuingAuthority } from '@/models/IssuingAuthority'
  import AlertBannerRecords from '@/components/shares/AlertBannerRecords.vue';

  const path = 'maestro/tickets/aggregation'
  const buildAuthorities = list => {
    if (list.length <= 10)
      return list

    const cloneList = [...list]
    cloneList.sort((a, b) => (a.sum < b.sum) ? 1 : ((b.sum < a.sum) ? -1 : 0))
    const newList = cloneList.slice(0, 9)
    const rest = cloneList.slice(9)

    newList.push({
      count: rest.map(e => e.count).reduce((a, b) => a + b),
      sum: rest.map(e => e.sum).reduce((a, b) => a + b),
      issuingAuthority: 'Outros',
    })

    return newList
  }

  export default {
    created() {
      this.$router.push('/cm-taxas')
    },
    components: {
      AlertBannerRecords, Card, CmFrotasChart, CmFrotasPieChart, Pagination, SearchIcon, InfoIcon, Vehicles, RefreshCcwIcon },
    computed: {
      queryDate() {
        return {
          start_date: this.startDate,
          end_date: this.endDate,
          period_type: this.periodType
        }
      },
      queryGeneric() {
        return this.generic ? { generic: this.generic } : {}
      },
    },
    data: () => ({
      building: false,
      objectLoad: {
        status: true,
        graph: true,
        graph1: true,
        vehicles: true,
      },
      startDate: '',
      endDate: '',
      periodType: 'occurred_at',
      generic: '',
      vehiclesMessage: 'Ainda não existem veículos cadastrados no sistema. <a href="/definitions?tab=vehicles">Clique aqui</a> para ir para o cadastro de veículos.',
      scheduleMessage: 'Ainda não existem taxas registradas no sistema. <a href="/cm-taxas/configuracoes">Clique aqui</a> para ir para o agendamento de consultas.',
      meta: {
        perPage: 5,
        currentPage: 1
      },
      classifications: [],
      listStatus: [{}, {}, {}],
      vehicles: [],
      issuingAuthorities: [],
    }),
    methods: {
      async initializeData() {
        const methods = [
          this.loadStatus,
          this.loadClassification,
          this.loadIssuingAuthority,
          this.loadVehicles,
        ]

        for (const method of methods)
          await method()
      },
      find() {
        this.meta.currentPage = 1
        this.loadVehicles()
      },
      loadClassification() {
        const params = {
          query: this.queryDate,
          aggregation: {
            sum: 'value_cents'
          },
          fields: ['ticket_class', 'ticket_subclass'],
          meta: false,
          per_page: 1000
        }

        this.objectLoad.graph = true
        return this.axios.get(path, { params })
          .then(response => this.classifications = this.$parse.toCamelcase(response.data))
          .finally(() => this.objectLoad.graph = false)
      },
      loadIssuingAuthority() {
        const params = {
          query: this.queryDate,
          aggregation: {
            sum: 'value_cents'
          },
          fields: ['issuing_authority'],
          meta: false,
          per_page: 1000
        }

        this.objectLoad.graph1 = true
        return this.axios.get(path, { params })
          .then(response => this.$parse.toCamelcase(response.data))
          .then(data => buildAuthorities(data))
          .then(authorities => authorities.map(a => [IssuingAuthority.label(a.issuingAuthority) || 'Sem informação', a.sum]))
          .then(data => this.issuingAuthorities = data)
          .finally(() => this.objectLoad.graph1 = false)
      },
      loadVehicles() {
        const params = {
          query: { ...this.queryDate, ...this.queryGeneric },
          aggregation: {
            sum: 'value_cents'
          },
          fields: ['plate', 'renavam', 'cnpj'],
          page: this.meta.currentPage,
          per_page: this.meta.perPage
        }

        this.objectLoad.vehicles = true
        return this.axios.get(path, { params })
          .then(response => {
            this.vehicles = this.$parse.toCamelcase(response.data)
            this.meta = this.$parse.toCamelcase(response.meta)
          })
          .finally(() => this.objectLoad.vehicles = false)
      },
      loadStatus() {
        const params = {
          query: {
            ...this.queryDate,
            status: ['paid', 'expired', 'opened']
          },
          aggregation: {
            sum: 'value_cents'
          },
          fields: ['status']
        }

        this.objectLoad.status = true
        return this.axios.get(path, { params })
          .then(response => response.data)
          .then(status => {
            const paid = {...(status.find(s => s.status === 'paid') || {}), title: 'PAGAS', color: 'green' }
            const expired = {...(status.find(s => s.status === 'expired') || {}), title: 'VENCIDAS', color: 'red' }
            const opened = {...(status.find(s => s.status === 'opened') || {}), title: 'EM ABERTO', color: 'yellow' }
            this.listStatus = [paid, expired, opened]
          })
          .finally(() => this.objectLoad.status = false)
      },
      pagination(page) {
        this.meta.currentPage = page
        this.loadVehicles()
      },
    },
    mixins: [GetAccount, GetAccountApps],
    name: 'DashboardCMTaxas',
  }
</script>

<style scoped>

  td {
    height: 56px;
  }

  .last-update{
    font-size: 14px;
    color:#051b307a;
  }
   .card{
     font-size: 12px;
   }

   .disabledDashboard {
     -webkit-user-select: none;
     -webkit-touch-callout: none;
     -moz-user-select: none;
     -ms-user-select: none;
     user-select: none;
     filter: blur(8px);
     -webkit-filter: blur(8px);
     z-index: 999;
   }

  .disabledDashboardButton {
    top: 40%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 999;
    padding: 5rem;
    background-color: #fff;
    border: solid #E1E3EB 1.5px;
    border-radius: 5px;
    justify-content: center;
  }

  p, strong {
    margin-bottom: 0.5rem;
  }

</style>
